import React, { Component } from "react";
import { Card, CardContent, CardHeader } from "../../ui/card";
import { userService } from "../../../_services";
import EditSheet from "./EditSheet";
import PricingSheetCard from "./PricingSheetCard";

class PricingSheetModule extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showEditPopup: false,
            pricingSheetData: [],
            sheetEditData: ''
        }
    }
    
    componentDidMount() {
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.getPricingSheets(Usermeta_Data.split(':')[0]);
    }
    
    getPricingSheets(UserId) {
        try {
            // Use PricingSheets API (correct endpoint: api/admin/PricingSheets)
            userService.PricingSheets(UserId).then((apiData) => {
                if (apiData && apiData.length > 0) {
                    this.setState({ pricingSheetData: apiData });
                }
            }).catch((err) => {
                console.error('Error fetching pricing sheets:', err);
            });
        } catch (err) {
            console.error('Error in getPricingSheets:', err);
        }
    }
    
    editSheet(sheetData) {
        this.setState({ sheetEditData: sheetData, showEditPopup: true })
    }
    
    hideEditSheetPopup() {
        this.setState({ sheetEditData: '', showEditPopup: false })
    }

    changeInSheet() {
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.getPricingSheets(Usermeta_Data.split(':')[0]);
    }

    render() {
        return (
            <>
                <Card className="border-gray-200 bg-white">
                    <CardHeader className="border-b border-gray-100 px-6 py-3">
                        <h3 className="text-lg font-semibold text-brand-dark">Pricing Sheets</h3>
                    </CardHeader>
                    <CardContent className="pt-6">
                        {this.state.pricingSheetData && this.state.pricingSheetData.length > 0 ? (
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 xl:grid-cols-3 gap-4">
                                {this.state.pricingSheetData.map((item, index) => (
                                    <PricingSheetCard 
                                        key={index} 
                                        sheetData={item}
                                        editSheet={() => this.editSheet(item)}
                                    />
                                ))}
                            </div>
                        ) : (
                            <p className="text-center text-gray-500 py-8">No pricing sheets available</p>
                        )}
                    </CardContent>
                </Card>
                
                {this.state.showEditPopup && (
                    <EditSheet 
                        sheetData={this.state.sheetEditData} 
                        hideModal={() => this.hideEditSheetPopup()} 
                        changeInSheet={() => this.changeInSheet()} 
                    />
                )}
            </>
        )
    }
}

export default PricingSheetModule;
